// Simple Analytics event tracking utility
export const trackEvent = (eventName: string, metadata?: Record<string, any>) => {
  if (window.sa_event) {
    window.sa_event(eventName, metadata);
  } else {
    console.log('Simple Analytics not loaded, would track:', eventName, metadata);
  }
};

// Declare the global sa_event function for TypeScript
declare global {
  interface Window {
    sa_event?: (eventName: string, metadata?: Record<string, any>) => void;
  }
}
